import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { GygStoreGroupType } from 'src/types/apps/gygStoreGroup'
import { GygStoreGroupChannelType } from 'src/types/apps/gygStoreGroupChannel'
import { Redux } from 'src/store'
import { GygChannels, GygAreas } from '@/src/types/apps/gygChannels'

type GygStoresGroupStateType = {
  gygStoreGroups: GygStoreGroupType[]
  gygStoreGroup: GygStoreGroupType | null
  gygStoreGroupChannel: GygStoreGroupChannelType[]
  gygChannels: GygChannels[]
  gygAreas: GygAreas[]
  pending: boolean
  getStoreGroupsPending: boolean
  gygStoreGroupChannelPending: boolean
  errors: any // todo
}

const initialState: GygStoresGroupStateType = {
  gygStoreGroups: [],
  gygStoreGroup: null,
  gygStoreGroupChannel: [],
  gygChannels: [],
  gygAreas: [],
  errors: {},
  pending: false,
  getStoreGroupsPending: false,
  gygStoreGroupChannelPending: false
}

interface GetStoreGroupsResponse {
  data: GygStoreGroupType[]
}

interface GetChannelsResponse {
  data: GygChannels[]
}
interface GetAreasResponse {
  data: GygAreas[]
}

interface GetStoreGroupChannelResponse {
  data: GygStoreGroupChannelType[]
}

export const gygStoreGroupLists = createAsyncThunk<GetStoreGroupsResponse, void, Redux>(
  'gygStoreTagsList/gygStoreGroup',
  async (_, { extra }) => {
    const response = await extra.httpClient(`groups`)

    return response.data
  }
)

export const gygChannelLists = createAsyncThunk<GetChannelsResponse, void, Redux>(
  'gygStoreTagsList/gygChannels',
  async (_, { extra }) => {
    const response = await extra.httpClient(`channels`)

    return response.data
  }
)

export const gygAreasList = createAsyncThunk<GetAreasResponse, void, Redux>(
  'gygStoreTagsList/gygAreas',
  async (_, { extra, rejectWithValue }) => {
    try {
      const response = await extra.httpClient(`resto365-area`)

      return response.data
    } catch (error: any) {
      if (error.response) {
        return rejectWithValue(error.response.data)
      }

      return rejectWithValue(error.message)
    }
  }
)

export const gygStoreGroupChannelLists = createAsyncThunk<GetStoreGroupChannelResponse, void, Redux>(
  'gygStoreTagsList/gygStoreGroupChannel',
  async (_, { extra }) => {
    const response = await extra.httpClient(`channel-group-stores`)

    return response.data
  }
)

export const gygStoreGroup = createSlice({
  name: 'gygStoreGroup',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder

      // All Store Tags get
      .addCase(gygStoreGroupLists.fulfilled, (state, action) => {
        state.gygStoreGroups = action.payload.data
        state.getStoreGroupsPending = false
      })
      .addCase(gygStoreGroupLists.pending, state => {
        state.getStoreGroupsPending = true
      })
      .addCase(gygStoreGroupLists.rejected, state => {
        state.getStoreGroupsPending = false
      })

      // All Store Channels get
      .addCase(gygChannelLists.fulfilled, (state, action) => {
        state.gygChannels = action.payload.data
        state.pending = false
      })
      .addCase(gygChannelLists.pending, state => {
        state.pending = true
      })
      .addCase(gygChannelLists.rejected, state => {
        state.pending = false
      })

      // All Store Areas get
      .addCase(gygAreasList.fulfilled, (state, action) => {
        state.gygAreas = action.payload.data
        state.pending = false
      })
      .addCase(gygAreasList.pending, state => {
        state.pending = true
      })
      .addCase(gygAreasList.rejected, state => {
        state.pending = false
      })

      // All Store Group Channel by id
      .addCase(gygStoreGroupChannelLists.fulfilled, (state, action) => {
        state.gygStoreGroupChannel = action.payload.data
        state.gygStoreGroupChannelPending = false
      })
      .addCase(gygStoreGroupChannelLists.pending, state => {
        state.gygStoreGroupChannelPending = true
      })
      .addCase(gygStoreGroupChannelLists.rejected, state => {
        state.gygStoreGroupChannelPending = false
      })
  }
})

export default gygStoreGroup.reducer
